import { useReducer } from 'react';
import { createReducer, IPaginationState } from 'src/utils/server-side-pagination';
import { useGetCustomersQuery } from 'src/store/slices/customersAPISlice';
import { useHasPermission } from 'src/lib/hooks/useHasPermission';
import { Permission } from 'src/assets/data/permissions';

export const ROWS_PER_PAGE = 10;

export const initialState: IPaginationState = {
  filters: {
    // The API scopes list endpoints by client through the `client_id` query param
    client_id: '',
  },
  sorting: {},
  page: 1,
};

export const useGetPaginatedCustomers = (clientId: string) => {
  const canRead = useHasPermission(Permission.ReadCustomer);
  const clientScopedState = { ...initialState, filters: { client_id: clientId } };
  const [state, dispatch] = useReducer(createReducer(clientScopedState), clientScopedState);

  const { data, isLoading, isFetching } = useGetCustomersQuery(
    { state, limit: ROWS_PER_PAGE },
    { refetchOnMountOrArgChange: true, skip: !canRead }
  );

  return {
    data: data?.data ?? [],
    totalPages: data?.totalPages,
    totalItems: data?.totalItems,
    paginationPage: data?.page,
    isLoading,
    isFetching,
    ...state,
    dispatch,
  };
};
